import MenuProvider from './MenuProvider';
import OrderFlowProvider from './OrderFlowProvider';
import PaymentFlowProvider from './PaymentFlowProvider';
import PromoCodeProvider from './PromoCodeProvider';
import AuthProvider from './AuthProvider';
import OrderStatusProvider from './OrderStatusProvider';

export default {
  MenuProvider,
  OrderFlowProvider,
  PaymentFlowProvider,
  PromoCodeProvider,
  AuthProvider,
  OrderStatusProvider,
};
